export const VISITOR_ID_PREFIX = 'GUEST_'
